<div class="cover-photo-container">
    <img decoding="async" src="/assets/srec-cover-photo-cropped.png" class="cover-photo"
        alt="Spruce-SREC-Cover-Photo" />
</div>
<div class="homepage-body-container">
    <div class="srec-header-container">
        <div class="srec-header-inner-container">
            <div *ngIf="!showPrereq" class="srec-header">
                <span class="srec-header-text">SREC Registration Page</span>
                <span class="srec-header-text">Make Passive Income From Your Solar Energy Production Today!</span>
                <div class="srec-subheader"> powered by Spruce Capital and Trade.</div>
                <button class="button-large" mat-flat-button [routerLink]="['/register']"
                    [fragment]="'srec-initiation'">
                    GET STARTED TODAY
                </button>
            </div>
        </div>
    </div>
    <div class="youtube-video-container">
        <video controls class="video-player" poster="/assets/video-thumbnail.png">
            <source src="/assets/Spruce Power Website Video Final.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </div>
    <div class="srec-info-container">
        <div class="srec-info">
            <div class="how-it-works-container">
                <div>
                    <h2 class="info-header">How It Works</h2>
                    <p class="info-text">Getting started with Spruce is simple. First, enter your contact information
                        and upload the required documentation;
                        if you’re missing any documents, Spruce will assist you in securing them.
                        Next, agree to the terms and conditions for SREC registration and submit your application.
                        A Spruce representative will follow up with any additional questions.
                        Once your application is complete, you can expect your first SRECs to be generated within 3-4
                        months.</p>
                </div>
                <div>
                    <img decoding="async" src="/assets/srec-infographic.webp"
                        style="width: 100%; height: auto; max-width: 100%; display: block; min-width: 500px;"
                        alt="Spruce-SREC-Infographic" />
                </div>
            </div>
            <h2 class="info-header">What Is An SREC?</h2>
            <ul class="info-list">
                <li class="info-text"><strong>SRECs (Solar Renewable Energy Certificates)</strong> are performance-based
                    incentives for solar energy production.</li>
                <li class="info-text">Homeowners earn <strong>one SREC for every 1,000 kWh (1 MWh)</strong> of solar
                    electricity generated.</li>
                <li class="info-text">SRECs are part of <strong>Renewable Portfolio Standards (RPS)</strong>, which
                    require utilities to source a portion of electricity from renewables.</li>
                <li class="info-text">Utilities purchase <strong>RECs (Renewable Energy Certificates)</strong> to meet
                    these RPS requirements.</li>
                <li class="info-text"><strong>RECs</strong> serve as proof of renewable energy production or procurement
                    by utilities.</li>
                <li class="info-text"><strong>SRECs</strong> are the solar-specific form of RECs.</li>
            </ul>
            <p class="info-text" style="margin-top: 20px;">Spruce Power is registered to trade SRECs in California,
                enabling the company to participate in the state's renewable energy market and further support its clean
                energy initiatives.</p>
            <h2 class="info-header">Partner With Spruce To Make Money Off Your SRECS</h2>
            <p class="info-text">Partner with Spruce to monetize your solar renewable energy credits (SRECS)
                effortlessly!</p>
            <ul class="info-list">
                <li class="info-text">Over 20,000 registered sites across California's major utility areas (PG&E, SDGE,
                    SCE).</li>
                <li class="info-text">Spruce Power is currently the only company offering public registration and
                    monetization services for SRECs.</li>
                <li class="info-text">Full-service handling of:
                    <ul class="info-sublist">
                        <li class="info-text">Registration with WREGIS (the regulatory body).</li>
                        <li class="info-text">Sale of SRECs.</li>
                        <li class="info-text">Ensuring no liability for the customer.</li>
                    </ul>
                </li>
                <li class="info-text">If registration fails, SREC rights revert to the customer.</li>
                <li class="info-text">Annual payments issued by Spruce each February for SRECs.</li>
                <li class="info-text">Payment amounts vary based on market conditions.</li>
            </ul>
        </div>
        <div>
            <div class="srec-header-inner-container">
                <div *ngIf="!showPrereq" class="srec-header">
                    <button class="button-large" mat-flat-button [routerLink]="['/register']">
                        GET STARTED TODAY
                    </button>
                </div>
            </div>
        </div>
        <div class="srec-info">
            <h2 class="info-header">When & How Do I Get Paid?</h2>
            <p class="info-text">Depending upon registration timing your first SRECs should be produced.</p>
            <p class="info-text">After each calendar year, Spruce will calculate your total SREC production, and the
                pricing received for the SRECs.</p>
            <p class="info-text">Prior to February 20<sup>th</sup> of the following year, Spruce will mail a check to
                the SREC owner for the value of SRECs sold. For example, if you register your system and produce SRECs
                in 2025, you will receive a check the following year on or before February 15th. 2026.</p>
            <p class="info-text">You can expect payment for your SRECs based on your registration timing and production.
                After each calendar year, Spruce will calculate your total SREC production, and the pricing received.
                Before February 20<sup>th</sup> of the following year, we will mail a check to the SREC owner for the
                value of the sold SRECs. For instance, if you register your system and produce SRECs in 2025, you will
                receive a check on or before February 15<sup>th</sup>, 2026.</p>
        </div>
    </div>
    <div style="margin-bottom: 32px;">
        <div class="srec-header-inner-container">
            <div *ngIf="!showPrereq" class="srec-header">
                <button class="button-large" mat-flat-button [routerLink]="['/register']">
                    GET STARTED TODAY
                </button>
            </div>
        </div>
    </div>
</div>